import React, { Component, useState } from 'react';
import { Modal, Typography, Upload, message } from 'antd';
import importProviderDownload from '../../../assets/importProviderDownload.png';
import importProviderUpload from '../../../assets/importProviderUpload.png';
import { ROOT_PATH } from '../../../origin';
import { getSignedQuery } from '../../../util/md5sign';
import { downLoad } from '../../../util/tool';
import './providerModal.less';
const { localStorage } = window;
const explainTexts = ['字段标准', '1.供应商采购平台编码：该编码为供应商在平台入驻时生成的编码', '2.ERP供应商：字符。', '3.ERP供应商二级细分：字符。'];
const BatchImportComponent = (props) => {
  const token = localStorage.getItem('token');
  const defaultHeader = token || '';
  const [errState, setErrState] = useState(false);
  const downloadTemplate = () => {
    downLoad({ url: `${ROOT_PATH}/assets/business-import.xlsx`, name: 'business-import.xlsx' });
  };

  const uploadProps = {
    name: 'file',
    action: getSignedQuery({ baseUrl: `${ROOT_PATH}/ipp/relation/batch` }),
    headers: {
      token: defaultHeader,
    },
    showUploadList: false,
    onChange(info) {
      const { file = {} } = info;
      const { status, name } = file;
      if (status === 'done') {
        const { response = {} } = file;
        const { code, msg } = response;
        if (+code === 0) {
          message.success(`${name}${msg}`, .5, props.handleOk());
        } else {
          message.error(`${msg}`, setErrState(true));
        }
      } else if (status === 'error') {
        message.error(`${name}上传失败！`, setErrState(true));
      }
    },
  };

  return (
    <div className='batch-import-container'>
      <div className='batch-import-img bitch-import-common' onClick={downloadTemplate}>
        <img src={importProviderDownload} alt='' />
        <div className='batch-import-template'>下载模版</div>
      </div>
      <Upload {...uploadProps}>
        <div className='batch-import-img bitch-import-common'>
          <img src={importProviderUpload} alt='' />
          <div className='batch-import-template'>
            <div className='batch-import-upload-template-text'>上传模版</div>
            {errState ? <Typography.Link>上传失败</Typography.Link> : null}
          </div>
        </div>
      </Upload>
      <div className='batch-import-explain-container bitch-import-common'>{explainTexts.map((item, index) => <div key={index} className='batch-import-explain'>{item}</div>)}</div>
    </div>
  );
};


export default class BatchImport extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    this.props.searchFn();
    this.props.hideModal(false);
  };

  handleCancel = () => {
    this.props.hideModal(false);
  };

  render() {
    return (
      <>
        <Modal
          className='add-provider-modal'
          open={true}
          title="批量导入"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <BatchImportComponent handleOk={this.handleOk} handleCancel={this.handleCancel} />
        </Modal>
      </>
    );
  }
}